var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from 'mobx';
import InvoicesAPI from '../services/InvoicesAPI';
import _groupBy from 'lodash/groupBy';
import { formatTimestamp } from '@bytebrand/fe-ui-core-autobahn/utils';
class InvoicesStore {
    constructor() {
        Object.defineProperty(this, "invoicesForOdooProductSale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "invoicesForOdooCarSale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "getInvoicesForOdooProductSale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeOfProduct, startDate, endDate) => {
                InvoicesAPI.getInvoicesForOdooProductSale(typeOfProduct, startDate, endDate)
                    .then((response) => {
                    this.invoicesForOdooProductSale.clear();
                    const groupedByMonth = _groupBy(response.result, (el) => formatTimestamp({ timestamp: el.date_invoice, format: 'YYYY-MM' }));
                    const orderedByDate = {};
                    Object.keys(groupedByMonth).sort((el, el2) => new Date(el).getTime() - new Date(el2).getTime()).forEach((key) => {
                        orderedByDate[key] = groupedByMonth[key];
                    });
                    if (typeOfProduct === 'odooCarSale') {
                        this.invoicesForOdooCarSale.replace(orderedByDate);
                    }
                    if (typeOfProduct === 'odooProductSale') {
                        this.invoicesForOdooProductSale.replace(orderedByDate);
                    }
                })
                    .catch((error) => {
                    if (error) {
                        this.error = true;
                    }
                });
            }
        });
        Object.defineProperty(this, "getInvoicesAPIURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, date) => {
                InvoicesAPI.getPDF(url, date);
            }
        });
        makeObservable(this);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], InvoicesStore.prototype, "invoicesForOdooProductSale", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], InvoicesStore.prototype, "invoicesForOdooCarSale", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], InvoicesStore.prototype, "error", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], InvoicesStore.prototype, "getInvoicesForOdooProductSale", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], InvoicesStore.prototype, "getInvoicesAPIURL", void 0);
export default new InvoicesStore();
